export enum ActivityPageTabs {
  ALL = 'ALL',
  NOTE = 'NOTE',
  CALL = 'CALL',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export enum ActivityType {
  NOTE = 'NOTE',
  CALL = 'CALL',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export interface ActivityListFilters {
  search: string;
  callFilters: {
    callStatus: string[];
    callDirection: string[];
  };
}

export interface ActivityCardProps<Entity> {
  entity: Entity;
  onUpdate?: VoidFunction;
  onDelete?: VoidFunction;
}

export interface SmsConversationData {
  voId: string;
  conversationSequenceNumber: number | null;
  contactId: string;
  contactName: string;
  contactPhone: string | null;
  contactTitle: string | null;
  contactInitials: string;
}

export interface SendMessageForm {
  message: string;
}
